import Vue from 'vue'
import App from './App'
import router from './router'
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
Vue.config.productionTip = false
import remConfig from './assets/js/rem.js'
remConfig();
/*vue-lazyload*/
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
/*element-ui*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import './assets/css/reset.css'
import './assets/css/border.css'
//数字金额三位加逗号
Vue.filter('capitalize', function (value) {
  	if(value<0){
  		return "-"
  	}
})
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js